// Web version - use URLs from public folder
export const omaCookieImage = {uri: '/oma-cookie.png'};
export const omaBinocularsImage = {uri: '/oma-binoculars.png'};
